import axios from '@/libs/api.request'


/**
 * 重新授权登录
 * 
 * @auther wxt.linx
 * @param url 当前跳转页面
 */
export const retryAuth = ({
	url
}) => {
	return axios.request({
		url: 'api/wechat/user/auth?url=' + url,
		method: 'get'
	})
}

/**
 * 微信用户登录
 * 
 * @auther wxt.linx
 * @param code 微信页面授权code
 */
export const login = (code) => {
	return axios.request({
		url: 'api/wechat/user/getUserByCode?code='+code,
		method: 'get'
	})
}

/**
 * 获取当前用户信息
 * 
 * @auther wxt.linx
 */
export const getUserInfo = () => {
	return axios.request({
		url: 'api/wechat/user/getUserInfo',
		method: 'get'
	})
}


// WEBPACK FOOTER //
// ./src/apis/auth.js